import { isStationEntry } from './stationEntry';
// Only the explicit station path loads terminal auth and reference screens.
if (isStationEntry(window.location.pathname)) {
  void import('./bootstrapStationAcceptance');
} else {
  void import('./bootstrapAdmin');
}
